module.exports = __webpack_public_path__ + "img/sv.44fd2006.svg";